import type { RouteLocationRaw } from 'vue-router'
import { filter, intersection, size } from 'lodash'
import SIDE_NAV from '@helm/constants/sideNav'
import type { SideNavItem, SideNavLocation } from '@helm/types/sideNav'
import type { HelmNavItem } from '@helm/types/helmMainNav'

// What a person with these permissions can see in a side nav: items with no roles are for everyone, the
// rest need at least one of theirs.
const visibleSideNavItems = (menu: SideNavLocation, permissions: string[]): SideNavItem[] =>
    filter(SIDE_NAV[menu], item => (item.roles ? Boolean(size(intersection(item.roles, permissions))) : true))

// Where a main nav tab should take them: the first page of that side nav they're allowed to open.
const firstSideNavRoute = (menu: SideNavLocation, permissions: string[]): RouteLocationRaw | undefined =>
    visibleSideNavItems(menu, permissions)[0]?.route

// Where a main nav tab links: the first page of its side nav the person can open, rather than a fixed one they
// might not be allowed into. Tabs without a side nav just go to their own path.
const mainNavDestination = (item: HelmNavItem, permissions: string[]): RouteLocationRaw =>
    (item.sideNav?.length ? firstSideNavRoute(item.sideNav[0], permissions) : undefined) ?? {
        path: item.path,
        name: item.name
    }

export { visibleSideNavItems, firstSideNavRoute, mainNavDestination }
